export const CACHE_TIME_1_HOUR = 60 * 60 * 1000; // 1 hour
export const CACHE_TIME_10_MINUTES = 10 * 60 * 1000; // 1 hour

export const CONTACT_FORM_ID = "contact-form-id";